import PropTypes from 'prop-types';

const imageProp = PropTypes.string;

const nextImageProp = PropTypes.shape({
  src: PropTypes.string.isRequired,
});

export const srcOrNextImageProp = PropTypes.oneOfType([nextImageProp, imageProp]);
